var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncentiveIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.215088 4C0.215088 1.79086 2.00595 0 4.21509 0H28.2151C30.4242 0 32.2151 1.79086 32.2151 4V28C32.2151 30.2091 30.4242 32 28.2151 32H4.21509C2.00595 32 0.215088 30.2091 0.215088 28V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2151 7V16C11.2151 16.55 11.6651 17 12.2151 17H14.2151V24.15C14.2151 24.66 14.8851 24.84 15.1451 24.4L20.3351 15.5C20.7251 14.83 20.2451 14 19.4751 14H17.2151L19.7051 7.35C19.9551 6.7 19.4751 6 18.7751 6H12.2151C11.6651 6 11.2151 6.45 11.2151 7Z",
    fill: "#CE9200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentiveIndicator);
export default __webpack_public_path__ + "static/media/incentive-indicator.d3ab1c90ea7a25b6a3e0222c9da76a46.svg";
export { ForwardRef as ReactComponent };